import React, { useEffect, useState } from "react";

import styles from "./index.module.scss";

import { Image } from "react-bootstrap";
import OTPInput from "react-otp-input";
import { useMutation } from "react-query";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { QuizAPI } from "../../Api/Quiz";
import SectionContainer from "../../Components/Container/SectionContainer";
import { Button, Header } from "../../Components/CustomComponent";
import { ROLE_TYPE_ENUM, STRING, WEB_ROUTES } from "../../constants";
import { useAppContext } from "../../Context/AppContext";
import { useSocket } from "../../Context/SocketContext";
import { baseRoute } from "../../Helper";
import { Toast } from "../../Hooks/useToast";

export default function TutorialLogin() {
  const socket = useSocket()
  const { user: { id }, isSocketConnected, isWebView } = useAppContext()
  const quizAPI = QuizAPI()
  const navigate = useNavigate()
  const [error, setError] = useState(false)
  const [isSubmitted, setSubmitted] = useState(false);
  const location = useLocation();
  const pin = location.state?.pin;
  const [searchParams, setSearchParams] = useSearchParams();
  const isPermanentClose = searchParams.get('isPermanentClose')
  const [otp, setOtp] = useState(pin || searchParams.get('code') || null);


  const quizMutation = useMutation(quizAPI.join, {
    onSuccess: ({ data }) => {
      if (data.user_id === id) {
        socket.emit('_joinQuizRoom', {
          quiz_id: data.id,
          type: ROLE_TYPE_ENUM.AUDIENCE
        })
      }
      else {
        navigate(baseRoute(WEB_ROUTES.QUIZ_GAME), {
          state: data
        })
      }
    },
    onError: (err) => {
      Toast(err.message || STRING.server_error, 'error', false);
      setSubmitted(false)
    }
  })


  useEffect(() => {
    if (isSocketConnected) {
      socket.on('quizJoined_', ({ data }) => {
        navigate(baseRoute(WEB_ROUTES.QUIZ_GAME), {
          state: {
            ...data.quiz,
            user_type: ROLE_TYPE_ENUM.AUDIENCE,
            audience_id: data.user_quiz.id
          }
        })
      })
    }

    return () => {
      socket.dispose('quizJoined_');
    }
  }, [isSocketConnected])

  const handleBackClick = () => {
    if (!isWebView && !isPermanentClose) return navigate(-1);

    if (window?.FlutterChannel) {
      window.FlutterChannel.postMessage("close");
    }
    else {
    }
  }

  const handleSubmit = () => {
    if (isSubmitted) return;
    if (otp.length !== 4) return setError(true)

    setSubmitted(true)
    quizMutation.mutate({ code: otp })
  }

  return (
    <div className={styles.Quiz}>
      <SectionContainer classes={`${styles.container} mx-auto d-flex justify-content-center`}>
        <span onClick={handleBackClick} className={`${styles.toggleButton} position-absolute `}>
          <img src="/assets/cross.png" />
          {/* <GiHamburgerMenu /> */}
        </span>
        <div className={`${styles.authTop}`}>
          <Image
            src="/assets/tutorial.png"
            alt="Navbar-Logo-Small"
            className={`${styles.large}`}
            responsive
          />
        </div>
        <div className={styles.titleContainer}>
          <div className={styles.logoContainer}>
            <Image
              src="/logo.png"
              alt="Navbar-Logo-Small"
              className={`${styles.large}`}
              responsive
            />
          </div>
          <Header text="Enter Pin" classes={styles.heading} />
          <div
            className={`${styles.otpInput} mb-3 d-flex justify-content-between align-items-center"`}
          >
            <OTPInput
              value={otp}
              onChange={setOtp}
              numInputs={4}
              inputType={"number"}
              renderInput={(props, index) => <input
                {...props}
                placeholder=""
                className={(error && (index + 1 > otp.length)) ? styles.error : ''}
                type="number"
                onFocus={(e) => {
                  setTimeout(() => {
                    e.target.scrollIntoView({ behavior: "smooth", block: "center" });
                  }, 50);
                }}
              />}
            //   renderInput={(props) => <input {...props} />}
            />
          </div>
          <Button
            text={<span className={`${styles.gradientText} ls-9 fw-bolder`}>Login</span>}
            lightTheme
            text_gradient
            isSubmitted={isSubmitted}
            onClick={handleSubmit}
            spinner_classes="text-black"
          />
        </div>
      </SectionContainer>
    </div>
  );
}
